import {
  Callout as SharedCallout,
  CalloutProps as SharedCalloutProps,
} from "@flaminem/ui-components";
import { FC } from "react";

export type CalloutProps = SharedCalloutProps;

export const Callout: FC<CalloutProps> = ({ ...props }) => {
  return <SharedCallout {...props} />;
};
